import { render } from "./CurrencyRatesView.vue?vue&type=template&id=e98ce252&scoped=true"
import script from "./CurrencyRatesView.vue?vue&type=script&lang=js"
export * from "./CurrencyRatesView.vue?vue&type=script&lang=js"

import "./CurrencyRatesView.vue?vue&type=style&index=0&id=e98ce252&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98ce252"]])

export default __exports__